module.exports = __webpack_public_path__ + "static/media/tippytop.dd8d46be.svg";